import "./App.css";
import MyRoutes from "./routes/myroutes";
function App() {
  return <MyRoutes />;
}

export default App;
